<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Raigad District-Level One-Day Chess Tournament</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span>G.H. Raisoni Memorial Raigad District-Level One-Day Chess Tournament Concludes
                    Successfully</span>
            </h2>
        </div>
        <p>The G.H. Raisoni Memorial Raigad District-Level One-Day Chess Tournament was successfully conducted at the
            centrally located Agroha Bhavan, Raigarh, under the joint aegis of the G.H. Raisoni Foundation and Kalpana
            Prakash Foundation. A total of 169 players from across the district participated with great enthusiasm.</p>
        <p>With a total prize fund of ₹30,000, awards were distributed among 32 players across the Open and Junior
            categories. The tournament aimed to encourage young talent and offer a strong competitive platform for
            emerging chess players in the district.</p>
        <hr>
        <h5 class="primary-purple"> Open Category Winners</h5>
        <ul class="list-style list-style1 mb-3  ">
            <p>The tournament was inaugurated with a ceremonial first move on the chessboard by dignitaries
                including:</p>
            <li><strong>1st Place:</strong> Gagan Sahu</li>
            <li><strong>2nd Place:</strong> Kirat Gujral</li>
            <li><strong>3rd Place:</strong> Aditya Agarwal</li>
            <li><strong>4th Place:</strong> Kshitij Agarwal</li>
            <li> <strong> 5th Place:</strong> Shubham Singh</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Category Winners
        </h5>
        <div class="list-count">
            <ul class="list-style list-style1 mb-3  ">
                <p> Under-7</p>
                <li><strong> 1st:</strong> Sarthak Agarwal</li>
                <li><strong>2nd: </strong> Shivansh Agarwal</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p>Under-9</p>
                <li><strong> 1st:</strong>Swara Borse</li>
                <li><strong>2nd: </strong>Naksh Nayak</li>
                <li><strong> 3rd:</strong> Nirbhay Singh
                </li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p>Under-11</p>
                <li><strong> 1st:</strong>Ardh Tiwari</li>
                <li><strong>2nd: </strong> Shatabdi Gupta</li>
                <li><strong> 3rd:</strong> Omprakash Shetty
                </li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p>Under-13</p>
                <li><strong> 1st:</strong>Praanjal Biswal</li>
                <li><strong>2nd: </strong> Harshit Gupta</li>
                <li><strong> 3rd:</strong> Sahil Patel</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p>Under-15</p>
                <li><strong> 1st:</strong>Gaurav Behra</li>
                <li><strong>2nd: </strong> Ardh Agarwal</li>
                <li><strong> 3rd:</strong> Naitik Choubey</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p>Special Awards</p>
                <li><strong>Best Female Player: </strong>Jisha Keshrwani</li>
                <li><strong> Youngest Player: </strong>Shashank Patel</li>
                <li><strong>Best Veteran Player:</strong> Basant Dubey</li>
            </ul>
        </div>
        <hr>
        <h5 class="primary-purple">
            Valedictory Ceremony</h5>
        <p>The closing ceremony was graced by Hon’ble MP Shri Radheshyam Rathiya (Raigarh).
            The program was chaired by Shri Alok Singh (Media In-Charge).
            Special Guests included Smt. Poonam Solanki (Councillor) and members of the Raigarh Municipal Corporation
            MIC.</p>
        <p>The Hon’ble MP praised the excellent organization and lauded the efforts of the G.H. Raisoni Foundation in
            promoting chess at the grassroots level.</p>

        <hr>
        <h5 class="primary-purple">Officials & Acknowledgements</h5>
        <p>Event details were shared by District Chess Association Secretary Shri Kartikeshwar Maithri.</p>
        <hr>
        <h5 class="primary-purple">Organizing Officials </h5>
        <p> Vice President: Shri Ramesh Padi</p>

        <p>Vice Secretary: Shri Ishwar Netam</p>

        <p> Executive Members: Mushtaq Momin, Akhil Pradhan, Indore Gond</p>

        <p> Senior Players: Vishnu Mishra, Dilip Namdev</p>

        <p>The tournament was conducted smoothly under the supervision of Chief Arbiters Shri Omprakash Vaidya and Shri
            Devendra (Bilaspur).</p>
        <hr>
        <h5 class="primary-purple">Special Appreciation </h5>
        <p> Congratulations were extended to all participants and winners by:</p>
        <p> District Chess Association President Shri Ashok Patel,</p>
        <p> Senior Mentor Shri Shiv Shankar Agarwal,</p>


        <!-- <hr>
        <h5 class="primary-purple"> Prize Distribution & Closing Ceremony</h5>
        <p>The closing ceremony was graced by <strong>Gyanesh Kumar Mishra,</strong> Superintendent of Post Offices,
            Bastar Division (Chief
            Guest), along with other guests of honor — <strong>Anand Agrawal, Ravindra Verma, Pradeep Sahu
            </strong>(International Softball
            Player), <strong>Ashok Tiwari</strong>, and <strong>Mrs. Laiba Chamadia</strong>, President, Inner Wheel
            Club, Jagdalpur.</p>
        <p> Chief Guest <strong>Gyanesh Kumar Mishra</strong> commended the association’s efforts and promised support
            for organizing a
            future chess event through the Postal Department.</p>
        <h5 class="primary-purple "> Winners List</h5>
        <div class="list-count">
            <ul class="list-style list-style1 mb-3  ">
                <p> <strong>Open Category</strong> </p>
                <li> Aman Raza</li>
                <li> Jai Singh Kashyap</li>
                <li> Sahil Sagar</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p> <strong>Under-17 (Girls) </strong></p>
                <li> Nishita Dewangan</li>
                <li> Purnima Sagar</li>
                <li> Arshiya Khan</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p> <strong>Under-17 (Boys) </strong></p>
                <li> Mayank Srivastava</li>
                <li>Yasir Pasha </li>
                <li> Divyaraj Jha</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-13 (Girls)</strong></p>
                <li>Alankrita Moharana</li>
                <li>Sakshi Kumari</li>
                <li>Avni Jaan</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-13 (Boys)</strong></p>
                <li>Swastik Sagar</li>
                <li> Suraj Verma</li>
                <li> Amartya Sarathi</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-9 (Boys)</strong></p>
                <li>Zidan Chamadia</li>
                <li> Vedant Shukla</li>
                <li> K. Bhuvan Abhinay</li>
            </ul>
            <ul class="list-style list-style1 mb-3  ">
                <p><strong>Under-9 (Girls)</strong></p>
                <li> Anushka Kumari</li>
                <li> Dhanshree Danda</li>
                <li> Ananya Srivastava</li>
            </ul>
        </div>
        <hr>
        <h5 class="primary-purple "> Technical Officials</h5>
        <ul class="list-style list-style1 mb-3  ">
            <li>Chief Arbiter: Tarun Sarathi</li>
            <li> Deputy Chief Arbiter: Ayaz Chamadia</li>
            <li> Arbiters: Abhinav Jena, Rajesh Jena, Purnima Saroj, and Jayashree Shende</li>
        </ul>
        <hr>
        <h5 class="primary-purple "> Organizing Committee </h5>
        <p>The event was successfully conducted under the leadership of <strong>Hitesh Tiwari</strong>, Secretary,
            Bastar District
            Chess Association, with valuable support from <strong>B.S. Dhruv, Sangeeta Tiwari, Sukirti Tiwari, Manju
                Sarathi, Ishwari Dhruv, Suchismita Jena, Lokesh Pandey, Minesh Panigrahi,</strong> and
            <strong>Abhishek Jena</strong>.
        </p>
        <p><strong>Shashank Sridhar </strong>, President of the Bastar District Chess Association and Joint
            Secretary of the
            Chhattisgarh State Chess Association, expressed gratitude to the <strong>Raisoni Foundation</strong> and
            <strong>Kalpana Prakash
                Welfare Foundation</strong> for their continued contributions to education and chess development
            across India.
        </p>
        <p>He highlighted that, under the guidance of <strong>Mr. Vinod Rathi</strong>, General Secretary of the
            Chhattisgarh Chess
            Association, a strong chess culture has flourished even in remote areas like Bastar.
            This event was particularly notable as the <strong>first Bastar Divisional Chess Tournament conducted
                entirely
                by local arbiters</strong> — a significant milestone for the region.</p> -->
        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-4.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</section>
